// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__MezOu","vLegacy":"SelectSecondary_vLegacy__28NYs","error":"SelectSecondary_error__3e8iT","disabled":"SelectSecondary_disabled__3IprV"};